import script from "./SelectableCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectableCard.vue?vue&type=script&setup=true&lang=ts"

import "./SelectableCard.vue?vue&type=style&index=0&id=37afffe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37afffe6"]])

export default __exports__